import { createNullableProvideInject } from '@collector/shared-ui'

import { EventInfoConfig } from '../configuration'

export const [provideEventInfoConfig, injectEventInfoConfig] =
  createNullableProvideInject<EventInfoConfig>('eventInfoConfig')
